<template>
    <div>
        <div class="listbanner">
            <a href="javascript:;" title="芙清动态">
                <img src="http://www.fulqun.com/images/listbanner1.jpg" alt />
            </a>
        </div>
        <div class="listbox">
            <div class="list">
                <ul class="news">
                    <li>
                        <a href="http://www.fulqun.com/news/2022/202203127.html" title="事件｜我们在武汉种了一些树，但不只是为了环保">
                            <img src="/var/folders/5p/t3skxlpx5wx0zy_g_78_bzl00000gn/T/com.tencent.WeWorkMac/wecom-temp-0ff17ff9375f1836de"
                                alt="事件｜我们在武汉种了一些树，但不只是为了环保" />
                        </a>
                        <dd>
                            <a href="http://www.fulqun.com/news/2022/202203127.html"
                                title="事件｜我们在武汉种了一些树，但不只是为了环保">事件｜我们在武汉种了一些树，但不只是为了环保</a>
                            <div>
                                如果有人问中国人一年要过多少个节日？绝大多数人恐怕很难立刻回答上来。但要聊起比较特殊的节日，植树节当在其中。40年前的今天，1982年3 ...
                                <a href="http://www.fulqun.com/news/2022/202203127.html" class="moreinfo">查看详情</a>
                            </div>
                            <p>
                                <span>2022-03-12</span>
                                <span></span>
                            </p>
                        </dd>
                    </li>
                    <li>
                        <a href="http://www.fulqun.com/news/2019/201908266.html" title="会讯|首届全国湿疹皮炎皮肤过敏学术会议回顾">
                            <img src="http://www.fulqun.com/uploadfile/2019/0902/20190902064710897.jpg"
                                alt="会讯|首届全国湿疹皮炎皮肤过敏学术会议回顾" />
                        </a>
                        <dd>
                            <a href="http://www.fulqun.com/news/2019/201908266.html"
                                title="会讯|首届全国湿疹皮炎皮肤过敏学术会议回顾">会讯|首届全国湿疹皮炎皮肤过敏学术会议回顾</a>
                            <div>
                                2019年6月29日，由中国中西医结合学会皮肤性病专业委员会主办的“首届国湿疹皮炎皮肤过敏学术会议”在上海圆满闭幕。...
                                <a href="http://www.fulqun.com/news/2019/201908266.html" class="moreinfo">查看详情</a>
                            </div>
                            <p>
                                <span>2019-08-26</span>
                                <span>芙清</span>
                            </p>
                        </dd>
                    </li>
                    <li>
                        <a href="http://www.fulqun.com/news/2019/201908265.html" title="会讯|第十六期全国激光美容与抗衰老新技术学习班落下帷幕">
                            <img src="http://www.fulqun.com/uploadfile/2019/0902/20190902071218268.jpg"
                                alt="会讯|第十六期全国激光美容与抗衰老新技术学习班落下帷幕" />
                        </a>
                        <dd>
                            <a href="http://www.fulqun.com/news/2019/201908265.html"
                                title="会讯|第十六期全国激光美容与抗衰老新技术学习班落下帷幕">会讯|第十六期全国激光美容与抗衰老新技术学习班落下帷幕</a>
                            <div>
                                2019年5月26日，第十六期全国激光美容与抗衰老新技术学习班在北京圆满结束，来自全国各地的400多名医疗工作者参加了此次学习。此次学习班的 ...
                                <a href="http://www.fulqun.com/news/2019/201908265.html" class="moreinfo">查看详情</a>
                            </div>
                            <p>
                                <span>2019-08-26</span>
                                <span></span>
                            </p>
                        </dd>
                    </li>
                    <li>
                        <a href="http://www.fulqun.com/news/2019/201908264.html" title="会讯|中华医学会第二十五次全国皮肤性病学术年会召开在即">
                            <img src="http://www.fulqun.com/uploadfile/2019/0902/20190902071657978.jpg"
                                alt="会讯|中华医学会第二十五次全国皮肤性病学术年会召开在即" />
                        </a>
                        <dd>
                            <a href="http://www.fulqun.com/news/2019/201908264.html"
                                title="会讯|中华医学会第二十五次全国皮肤性病学术年会召开在即">会讯|中华医学会第二十五次全国皮肤性病学术年会召开在即</a>
                            <div>
                                2019年4月25日～28日，由中华医学会皮肤性病学分会举办的中华医学会第二十五次全国皮肤性病学术年会将于广东省珠海市珠海国际会展中心召开 ...
                                <a href="http://www.fulqun.com/news/2019/201908264.html" class="moreinfo">查看详情</a>
                            </div>
                            <p>
                                <span>2019-08-26</span>
                                <span></span>
                            </p>
                        </dd>
                    </li>
                    <li>
                        <a href="http://www.fulqun.com/news/2019/201908263.html" title="会讯|第九届全国激光美容与面部年轻化学术大会圆满落幕">
                            <img src="http://www.fulqun.com/uploadfile/2019/0902/20190902074954228.jpg"
                                alt="会讯|第九届全国激光美容与面部年轻化学术大会圆满落幕" />
                        </a>
                        <dd>
                            <a href="http://www.fulqun.com/news/2019/201908263.html"
                                title="会讯|第九届全国激光美容与面部年轻化学术大会圆满落幕">会讯|第九届全国激光美容与面部年轻化学术大会圆满落幕</a>
                            <div>
                                就在上周，在厦门和北京举办的两大皮肤医美会议圆满落幕。芙清芙汭除了受邀参展以外，还在厦门举办了骆丹教授和杨蓉娅教授的签赠活动，下面 ...
                                <a href="http://www.fulqun.com/news/2019/201908263.html" class="moreinfo">查看详情</a>
                            </div>
                            <p>
                                <span>2019-08-26</span>
                                <span></span>
                            </p>
                        </dd>
                    </li>
                    <li>
                        <a href="http://www.fulqun.com/news/2019/201908262.html" title="会讯|第九届全国激光美容与面部年轻化学术大会召开在即">
                            <img src="http://www.fulqun.com/uploadfile/2019/0902/20190902075036642.jpg"
                                alt="会讯|第九届全国激光美容与面部年轻化学术大会召开在即" />
                        </a>
                        <dd>
                            <a href="http://www.fulqun.com/news/2019/201908262.html"
                                title="会讯|第九届全国激光美容与面部年轻化学术大会召开在即">会讯|第九届全国激光美容与面部年轻化学术大会召开在即</a>
                            <div>
                                就在下周3月21日&mdash;3月24日，由中国医师协会、中国医师协会美容与整形分会主办的第九届全国激光美容与面部年轻化学术大会暨中国（厦门）国际 ...
                                <a href="http://www.fulqun.com/news/2019/201908262.html" class="moreinfo">查看详情</a>
                            </div>
                            <p>
                                <span>2019-08-26</span>
                                <span></span>
                            </p>
                        </dd>
                    </li>
                    <li>
                        <a href="http://www.fulqun.com/news/2019/201908261.html" title="会讯|2019广西皮肤性病科专科联盟发展论坛圆满落幕">
                            <img src="http://www.fulqun.com/uploadfile/2019/0902/20190902080546197.jpg"
                                alt="会讯|2019广西皮肤性病科专科联盟发展论坛圆满落幕" />
                        </a>
                        <dd>
                            <a href="http://www.fulqun.com/news/2019/201908261.html"
                                title="会讯|2019广西皮肤性病科专科联盟发展论坛圆满落幕">会讯|2019广西皮肤性病科专科联盟发展论坛圆满落幕</a>
                            <div>
                                上周日2月24日，2019年广西皮肤性病学新进展新技术国家级继续教育学习班暨广西皮肤性病科专科联盟发展论坛于南宁圆满落幕。开幕式后，大会 ...
                                <a href="http://www.fulqun.com/news/2019/201908261.html" class="moreinfo">查看详情</a>
                            </div>
                            <p>
                                <span>2019-08-26</span>
                                <span></span>
                            </p>
                        </dd>
                    </li>
                </ul>
                <div class="pages">
                    <a class="a1">上一页</a>
                    <span>1</span>
                    <a class="a1">下一页</a>
                </div>
            </div>
        </div>
        <div class="footer">
            <ul class="putbox">
                <li>芙清fulqun官网</li>
                <li>Beijing FulQun Bio-Technology Co. Ltd</li>
                <li>北京芙清生物科技有限公司©</li>
                <li>地址：北京市丰台区南四环西路186号汉威国际广场二区9号楼6层03-07室</li>
                <li>
                    <a href="https://beian.miit.gov.cn/">京ICP备19037671号-1</a>
                </li>
                <li @click="() => { this.$router.push('/img') }">
                    互联网药品信息服务资格证书
                </li>
            </ul>
            <div class="contactbox">
                <p>400-010-2266</p>
                <p>周一至周五 9:00-17:30</p>
                <p>在线客服</p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            Listdata: [{
                title: '会讯|首届全国湿疹皮炎皮肤过敏学术会议回顾',
                content: '2019年6月29日，由中国中西医结合学会皮肤性病专业委员会主办的“首届国湿疹皮炎皮肤过敏学术会议”在上海圆满闭幕。',
                time: '2019-08-26',
                brand: '芙清',
                image: 'http://www.fulqun.com/uploadfile/2019/0902/20190902064710897.jpg'
            }, {
                title: '会讯|第十六期全国激光美容与抗衰老新技术学习班落下帷幕',
                content: '2019年5月26日，第十六期全国激光美容与抗衰老新技术学习班在北京圆满结束，来自全国各地的400多名医疗工作者参加了此次学习。此次学习班的',
                time: '2019-08-26',
                brand: '',
                image: 'http://www.fulqun.com/uploadfile/2019/0902/20190902071218268.jpg'
            }, {
                title: '会讯|中华医学会第二十五次全国皮肤性病学术年会召开在即',
                content: '2019年4月25日～28日，由中华医学会皮肤性病学分会举办的中华医学会第二十五次全国皮肤性病学术年会将于广东省珠海市珠海国际会展中心召开',
                time: '2019-08-26',
                brand: '',
                image: 'http://www.fulqun.com/uploadfile/2019/0902/20190902071657978.jpg'
            }],
            images: [
                "https://uplabimg.andupchain.com/%E5%AE%98%E7%BD%91/2d6dd2e5-2093-481b-82df-cd52161e40e5.png",
            ],
        }
    },
    methods: {
        news(i) {
            console.log(i);
            switch (i) {
                case 0:
                    this.$router.push('/one');
                    break;
                case 1:
                    this.$router.push('/two');
                    break;
                case 2:
                    this.$router.push('/three');
                    break;
                default:
                    break;
            }
        },
        go() {
            this.$router.push('/certification')
        }
    }
}
</script>

<style scoped>
.listbanner {
    width: 100%;
    overflow: hidden;
}

.listbanner img {
    width: 100%;
    height: auto;
    display: block;
}

.pages {
    width: 330px;
    margin: 0 auto;
    margin-top: 2rem;
    overflow: hidden;
    margin-bottom: 2rem;
}

.pages a,
.pages span {
    display: block;
    float: left;
    padding: 0 10px;
    text-align: center;
    height: 25px;
    line-height: 25px;
    border: solid 1px #7d7d7d;
    margin: 0 2px;
    font-size: 12px;
    cursor: pointer;
}

.pages span {
    height: 27px;
    line-height: 27px;
    background: #1b6ab4;
    border: none;
    color: #fff;
}

.list {
    width: 80%;
    max-width: 700px;
    margin: 0 auto;
    overflow: hidden;
}

.news li {
    overflow: hidden;
    margin-bottom: 2rem;
}

.news li img {
    display: block;
    width: 20%;
    float: left;
}

.news li dd {
    width: 77%;
    float: right;
    margin-top: 0;
    margin-left: 10px;
    color: #333;
    font-size: 13px;
}

.news li dd a {
    color: #333;
    font-weight: bold;
    font-size: 15px;
}

.news li dd div {
    margin: 0.6rem 0;
}

.news li dd span {
    color: #666;
    margin-right: 1rem;
    font-size: 12px;
}

.news li dd a.moreinfo {
    color: #075677;
    font-weight: 500;
    font-size: 13px;
}

.footer {
    height: 200px;
    padding: 30px;
    background-color: rgb(250, 250, 250);
    display: flex;
    justify-content: space-between;
}

.putbox {
    list-style: none;
    font-size: 12px;
    width: 70%;
    margin-top: 10px;
    padding-left: 10%;
    line-height: 30px;
}

.putbox a {
    text-decoration: none;
    color: #666;
}

.contactbox {
    width: 30%;
    height: 100%;
    text-align: center;
    line-height: 50px;
}

.contactbox p:nth-child(1) {
    color: rgb(65, 110, 179);
    font-size: 28px;
}

.contactbox p:nth-child(2) {
    font-size: 14px;
    color: #666;
}

.contactbox p:nth-child(3) {
    width: 180px;
    height: 36px;
    margin: auto;
    border: 1px solid rgb(65, 110, 179);
    color: rgb(65, 110, 179);
    line-height: 36px;
    cursor: pointer;
}
</style>
